import { ListPaginationMeta } from "utils/helpers/pagination";

export enum CustomerStatus {
  ACTIVE = "פעיל",
  INACTIVE = "לא פעיל",
}

export enum CustomerDetailStatus {
  DRAFT = "draft",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum CustomerPriceQuoteStatus {
  DRAFT = "DRAFT",
  SENT = "SENT",
  ACCEPTED = "ACCEPTED",
}

export enum CustomerPriceQuoteProjectType {
  RefrigeratedTrailer = "CUSTOMERS.DETAILS.MOCK.PRICE_QUOTES.REFRIGERATED_TRAILER",
  HeavyTipper = "CUSTOMERS.DETAILS.MOCK.PRICE_QUOTES.HEAVY_TIPPER",
  CustomOpenBody = "CUSTOMERS.DETAILS.MOCK.PRICE_QUOTES.CUSTOM_OPEN_BODY",
}

export interface CustomerPriceQuote {
  id: string;
  quoteNumber: string;
  createdAt: string;
  projectTypeKey: string;
  revisionNumber: number;
  totalValue: number;
  status: CustomerPriceQuoteStatus;
  validUntil: string;
}

export type CustomerWorkOrderPriority = "HIGH" | "MEDIUM" | "NORMAL";

export type CustomerWorkOrderStage =
  | "PAINT"
  | "METALWORK"
  | "QUALITY_CONTROL_STAGE";

export type CustomerWorkOrderStatus = "IN_PRODUCTION";

export type FinancialType = "CHECK" | "RECEIPT"

export type FinancialStatus = "PAID" | "SETTLED" | "OVERDUE"

export interface CustomerWorkOrder {
  id: number;
  workOrderId: string;
  status: CustomerWorkOrderStatus;
  vehicleKey: string;
  currentStage: CustomerWorkOrderStage;
  progress: number;
  priority: CustomerWorkOrderPriority;
}

export interface Financial{ 
  id: number;
  Date: string;
  DocumentNumber: number;
  Type: FinancialType;
  Description: string;
  SumUp: number;
  FinancialStatus: FinancialStatus;
  Download: any; //change later
}

export interface CustomerDocument {
  id: number;
  documentName: string;
  connectedVehicle: string;
  uploadedBy: string;
  date: string;
}

export type CustomerActivityType = "WORK_ORDER" | "FINANCIAL" | "CUSTOMER";

export interface CustomerActivity {
  id: number;
  type: CustomerActivityType;
  title: string;
  description: string;
  date: string;
}

export enum CustomerDetailTab {
  PRICE_QUOTE = "PRICE_QUOTE",
  WORK_INSTRUCTIONS = "WORK_INSTRUCTIONS",
  FINANCIAL = "FINANCIAL",
  FILES = "FILES",
  TIMELINE = "TIMELINE",
}

export const CUSTOMER_DETAIL_TAB_LABELS: Record<CustomerDetailTab, string> = {
  [CustomerDetailTab.PRICE_QUOTE]: "CUSTOMERS.DETAILS.TABS.PRICE_QUOTE",
  [CustomerDetailTab.WORK_INSTRUCTIONS]:
    "CUSTOMERS.DETAILS.TABS.WORK_INSTRUCTIONS",
  [CustomerDetailTab.FINANCIAL]: "CUSTOMERS.DETAILS.TABS.FINANCIAL",
  [CustomerDetailTab.FILES]: "CUSTOMERS.DETAILS.TABS.FILES",
  [CustomerDetailTab.TIMELINE]: "CUSTOMERS.DETAILS.TABS.TIMELINE",
};

export const CUSTOMER_DETAIL_TAB_ACTION_LABELS: Record<
  CustomerDetailTab,
  string
> = {
  [CustomerDetailTab.PRICE_QUOTE]: "CUSTOMERS.DETAILS.ACTIONS.ADD_PRICE_QUOTE",
  [CustomerDetailTab.WORK_INSTRUCTIONS]:
    "CUSTOMERS.DETAILS.ACTIONS.ADD_WORK_ORDER",
  [CustomerDetailTab.FINANCIAL]: "CUSTOMERS.DETAILS.ACTIONS.ADD_FINANCIAL",
  [CustomerDetailTab.FILES]: "CUSTOMERS.DETAILS.ACTIONS.ADD_FILE",
  [CustomerDetailTab.TIMELINE]: "CUSTOMERS.DETAILS.ACTIONS.ADD_TIMELINE",
};

export type CustomerStatusFilter = CustomerStatus | "ALL";

export interface Customer {
  customerId: number;
  customerName: string;
  customerShortName: string;
  category: string;
  contactPersonName: string;
  contactPhone: string;
  fax: string;
  address: string;
  moreDetails: string;
  activeWorkOrdersCount: number;
  totalRevenue: number;
  status: string;
}

export interface CustomerListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: Customer[];
  meta?: ListPaginationMeta;
}

export interface CustomerForm {
  customerName: string;
  category: string;
  contactPerson: string;
  contactPhone: string;
  contactEmail: string;
}

export interface contactForm {
  contactName: string;
  role: string;
  phoneNo: string;
  email: string;
}

export type CustomerSelectOption = {
  value: string;
  labelKey?: string;
  label?: string;
};

export type fieldConfig = {
  key: keyof CustomerForm | keyof contactForm;
  label: string;
  type: "select" | "text";
  options?: CustomerSelectOption[];
  placeholder?: string;
};

export interface CustomerContactPerson {
  contactId: number;
  customerId: number;
  contactName: string;
  role: string;
  phoneNo: string;
  email: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface CustomerDetails {
  customerId: number;
  customerName: string;
  customerShortName: string;
  category: string;
  contactPersonName: string;
  contactPhone: string;
  fax: string;
  address: string;
  moreDetails: string;
  activeWorkOrdersCount: number;
  totalRevenue: number;
  status: string;
  contacts: CustomerContactPerson[];
  priceQuotes: CustomerPriceQuote[];
  workOrders: CustomerWorkOrder[];
  Financial: Financial[]
  documents: CustomerDocument[]
  timeline: CustomerActivity[]
}

export interface CustomerDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: CustomerDetails;
}

export interface CustomerUpdate {
  id: number;
  customerShortName: string;
  customerName: string;
  category: string;
  contactPhone: string;
  fax: string;
  address: string;
  contactPersonName: string;
  moreDetails: string;
  status: string;
}

export interface CustomerContactUpdate {
  contactId: number;
  contactName: string;
  role: string;
  phoneNo: string;
  email: string;
}

export interface CustomerContactCreate {
  id: number;
  contactName: string;
  role: string;
  phoneNo: string;
  email: string;
}

export interface DocumentUploadFile {
  name: string;
  url: string;
}

export interface CustomersState {
  loading: boolean;
  saving: boolean;
  list: Customer[];
  statusFilter: CustomerStatusFilter;
  selectedCustomerId: string | null;
  customerDetails: CustomerDetails | null;
  detailLoading: boolean;
  error: string | null;
  isAddModalOpen: boolean;
  isAddContactModalOpen: boolean;
  isAddDocumentModalOpen: boolean;
  documentUploadFile: DocumentUploadFile | null;
  documentUploadError: string;

  form: CustomerForm;
  page: number;
  perPage: number;
  meta: ListPaginationMeta;

  contactForm: contactForm;
  contactSaving: boolean;
}
